module.exports = __webpack_public_path__ + "static/media/group4080.eee14607.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group4080.png
// module id = 1273
// module chunks = 1